// src/pages/Modules/ServiceRequestModule.jsx
// Landing page of the Online Service / Finance Service / Insurance modules (one request list each).
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Grid, CardActionArea, CircularProgress } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import SavingsIcon from '@mui/icons-material/Savings';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { usePermissions } from '../../context/PermissionContext';
import BackButton from '../../components/BackButton';

const MODULES = {
  online: { heading: 'ONLINE SERVICE MODULE', icon: LanguageIcon, card: 'Online Service Requests', path: '/online-service/requests', perm: 'onlineService.requests', description: 'View and complete Online Service requests (PAN, Aadhaar, certificates...) from customers' },
  finance: { heading: 'FINANCE SERVICE MODULE', icon: SavingsIcon, card: 'Finance Service Requests', path: '/finance-service/requests', perm: 'financeService.requests', description: 'View and complete Finance Service requests (pension, bank account, fixed deposit...) from customers' },
  insurance: { heading: 'INSURANCE MODULE', icon: HealthAndSafetyIcon, card: 'Insurance Requests', path: '/insurance/requests', perm: 'insuranceService.requests', description: 'View and complete Insurance requests from customers' },
};

const ServiceRequestModule = ({ kind }) => {
  const { can, loading } = usePermissions();
  const navigate = useNavigate();
  const m = MODULES[kind] || MODULES.online;
  const Icon = m.icon;

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', padding: 3 }}>
      <BackButton />
      <br /><br />
      <Box sx={{ width: '100%', p: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Icon fontSize="large" color="primary" />
          {m.heading}
        </Typography>
        <Grid container spacing={3}>
          {can(m.perm) && (
            <Grid item xs={12} sm={6} md={4}>
              <Card elevation={3} sx={{ height: '100%', borderRadius: 3, transition: 'transform 0.2s, box-shadow 0.2s', '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 } }}>
                <CardActionArea onClick={() => navigate(m.path)} sx={{ height: '100%', p: 2 }}>
                  <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box sx={{ mb: 2 }}><AssignmentIcon sx={{ fontSize: 50, color: 'primary.main' }} /></Box>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>{m.card}</Typography>
                    <Typography variant="body2" color="text.secondary">{m.description}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
};

export default ServiceRequestModule;
